<template>
  <DefaultLayout
    :pageProps="{
      title: 'Change email',
      description:
        step === 1
          ? 'Please enter your current credentials to proceed'
          : 'Please choose your new email and password',
    }"
  >
    <template #content>
      <div style="display: flex; flex-direction: column; gap: 20px">
        <LoginForm v-if="step === 1" button_text="Next" @success="next" />
        <ChangeEmail v-if="step === 2" />
      </div>
    </template>
  </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layout/DefaultLayout.vue";
import ChangeEmail from "@/components/forms/ChangeEmail.vue";
import LoginForm from "@/components/forms/loopLogin/LoginForm.vue";
export default {
  name: "index",
  components: {
    LoginForm,
    ChangeEmail,
    DefaultLayout,
  },
  watch: {
    $route(to) {
      this.step = parseInt(to.params.step, 10);
    },
  },
  data() {
    return {
      step: 1,
    };
  },
  mounted() {
    localStorage.clear();
    this.step = parseInt(this.$route.params.step);
  },
  methods: {
    next() {
      this.step = this.step + 1;
      this.$router.push(`/change-email/${this.step}`);
    },
  },
};
</script>
